import React, { useState } from "react";
import counts from "../../api/counts";
export default function Counts() {
  const [count, setCounta] = useState(counts);
  return (
    <section id="counts" className="counts">
      <div className="container" data-aos="fade-up">
        <div className="row">
          {count.map((curElem) => {
            const { id, icon, title, description } = curElem;
            return (
              <>
                <div className="col-lg-3 col-md-6" key={id}>
                  <div className="count-box">
                    <i className={icon}></i>
                    <span
                      data-purecounter-start="0"
                      data-purecounter-end="232"
                      data-purecounter-duration="1"
                      className="purecounter"
                    ></span>
                    <p>{title}</p>
                    <h1>{description}</h1>
                  </div>
                </div>
              </>
            );
          })}
        </div>
      </div>
    </section>
  );
}

// {counta.map(()=>(
//   <div className="col-lg-3 col-md-6"  key={count.id}>
//     <div className="count-box">
//       <i className={count.icon}></i>
//       <span data-purecounter-start="0" data-purecounter-end="232" data-purecounter-duration="1" className="purecounter"></span>
//       <p>{count.title}</p>
//       <h1>{count.description}</h1>
//     </div>
//   </div>))}
